<template>
  <div class="owner-tools">
    <div class="tools-head">
      <p class="eyebrow">Owner Tools</p>
      <h2>Manage employees and users</h2>
    </div>

    <el-tabs v-model="activeSection" type="border-card" class="owner-tabs">
      <el-tab-pane name="approve-employee">
        <template #label>
          <span class="tab-label">
            Approve Employee
            <el-badge :value="pendingApprovals" class="inline-badge" />
          </span>
        </template>
        <OwnerApprovalsPanel
          :current-user="currentUser"
          :owner-profile="ownerProfile"
          @countChanged="pendingApprovals = $event"
        />
      </el-tab-pane>

      <el-tab-pane name="employees" label="All Employees">
        <OwnerDirectoryPanel
          role="Admin"
          title="List of all employees"
          description="All users who currently have the admin role are listed here."
          search-placeholder="Search employees by name or email"
        />
      </el-tab-pane>

      <el-tab-pane name="users" label="All Users">
        <OwnerDirectoryPanel
          role="User"
          title="List of all users"
          description="All users who currently have the user role are listed here."
          search-placeholder="Search users by name or email"
        />
      </el-tab-pane>

      <el-tab-pane name="add-employee" label="Add Employee">
        <OwnerAddEmployeePanel
          :current-user="currentUser"
          :owner-profile="ownerProfile"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import OwnerAddEmployeePanel from '@/components/OwnerAddEmployeePanel.vue'
import OwnerApprovalsPanel from '@/components/OwnerApprovalsPanel.vue'
import OwnerDirectoryPanel from '@/components/OwnerDirectoryPanel.vue'
import { watchPendingEmployeeApprovals } from '@/services/owner'

export default {
  name: 'OwnerToolsPanel',
  components: {
    OwnerAddEmployeePanel,
    OwnerApprovalsPanel,
    OwnerDirectoryPanel,
  },
  props: {
    currentUser: {
      type: Object,
      default: null,
    },
    ownerProfile: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      activeSection: 'approve-employee',
      pendingApprovals: 0,
      pendingUnsub: null,
    }
  },
  mounted() {
    this.subscribePendingApprovals()
  },
  beforeUnmount() {
    this.pendingUnsub && this.pendingUnsub()
  },
  methods: {
    subscribePendingApprovals() {
      this.pendingUnsub && this.pendingUnsub()
      this.pendingUnsub = watchPendingEmployeeApprovals((rows) => {
        this.pendingApprovals = rows.length
      })
    },
  },
}
</script>

<style scoped>
.owner-tools {
  display: grid;
  gap: 16px;
}

.eyebrow {
  margin: 0 0 6px;
  color: #0b6cff;
  font-size: 0.82rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

h2 {
  margin: 0 0 6px;
  color: #03241f;
  font-size: 1.5rem;
  font-weight: 850;
}

.owner-tabs {
  border-radius: 22px;
  overflow: hidden;
  border: 1px solid rgba(0, 56, 49, 0.12);
  background: transparent;
}

.inline-badge {
  margin-left: 6px;
}

.inline-badge :deep(.el-badge__content) {
  position: static;
  transform: none;
}

.tab-label {
  display: inline-flex;
  align-items: center;
}

:deep(.el-tabs__content) {
  padding: 18px;
  background:
    radial-gradient(circle at top right, rgba(11, 108, 255, 0.06), transparent 32%),
    linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
}
</style>
